import { combineReducers } from "redux";
import accts from "./accts/acctsReducer";
import auth from "./auth/authReducer";
import contact from "./contact/contactReducer";
import document from "./document/documentReducer";
import ui from "./ui/uiReducer";
import validation from "./validation/validationReducer";
import profile from "./profile/profileReducer";
import payment from "./payment/paymentReducer";
import rpc from "./rpc/rpcReducer";
import i18n from "./i18n/i18nReducer";
import routing from "./routing/routingReducer";
/* combine reducers into one single parent */
export default combineReducers({
    accts,
    auth,
    contact,
    document,
    i18n,
    payment,
    profile,
    routing,
    rpc,
    ui,
    validation
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/reducers.ts